// eslint-disable-next-line import/no-cycle
import { useGlobalStore } from '@/stores/globalStore';
import http from './http';
import useErrorHandling from './useErrorHandling';

const readPersistentToken = (key) => {
  const persisted = localStorage.getItem(key);
  if (persisted !== null) {
    return persisted;
  }

  const legacy = sessionStorage.getItem(key);
  if (legacy !== null) {
    localStorage.setItem(key, legacy);
    sessionStorage.removeItem(key);
    return legacy;
  }

  return null;
};

export default () => {
  const { handleServerErrors } = useErrorHandling();

  const resetFetchingState = () => {
    const globalStore = useGlobalStore();
    globalStore.fetchingToken = false;
    globalStore.pendingTokenPromise = null;
  };

  const getToken = async () => http
      .get('/token')
      .then((response) => {
        const token = response.data.bearer_token;
        const globalStore = useGlobalStore();
        localStorage.setItem('token', token);
        globalStore.token = token;

        return token;
      })
      .catch((err) => {
        handleServerErrors(err);
        throw err;
      });

  const checkAndSyncExistingToken = () => {
    const globalStore = useGlobalStore();
    const storageToken = readPersistentToken('token');
    const storeToken = globalStore.token;
    const existingToken = storageToken || storeToken;

    if (!storageToken && storeToken) {
      localStorage.setItem('token', storeToken);
    }

    if (!storeToken && storageToken) {
      globalStore.token = storageToken;
    }

    return existingToken;
  };

  const handlePendingTokenFetch = async () => {
    const globalStore = useGlobalStore();
    if (!globalStore.pendingTokenPromise) {
      return null;
    }

    try {
      return await globalStore.pendingTokenPromise;
    } catch (error) {
      resetFetchingState();
      throw error;
    }
  };

  const performTokenFetch = async () => {
    const globalStore = useGlobalStore();
    globalStore.fetchingToken = true;

    globalStore.pendingTokenPromise = (async () => {
      try {
        await http.get('/csrf-cookie').catch((err) => {
          handleServerErrors(err);
          throw err;
        });

        const authToken = await getToken();

        return authToken;
      } finally {
        resetFetchingState();
      }
    })();

    return globalStore.pendingTokenPromise;
  };

  const fetchAuthToken = async () => {
    const globalStore = useGlobalStore();
    const existingToken = checkAndSyncExistingToken();

    if (existingToken) {
      return existingToken;
    }

    if (globalStore.fetchingToken) {
      return handlePendingTokenFetch();
    }

    return performTokenFetch();
  };

  const clearAuthToken = () => {
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    const globalStore = useGlobalStore();
    globalStore.token = null;
    resetFetchingState();
  };

  const setAuthToken = (token) => {
    localStorage.setItem('token', token);
    const globalStore = useGlobalStore();
    globalStore.token = token;
  };

  return {
    fetchAuthToken,
    clearAuthToken,
    setAuthToken,
  };
};
